module.exports = __webpack_public_path__ + "media/images/illustrations/self_storage_unit-4de31a2ac7f3f2ee62b1907e8ec1c914.svg";